import { z } from "zod";
import type {
    WeeklySchedule} from "../../weekly-schedules/weekly-schedule";
import {
    weeklyScheduleZodSchema,
} from "../../weekly-schedules/weekly-schedule";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderSetBusinessHoursCommand = {
    _type: "PROVIDER_SET_BUSINESS_HOURS_COMMAND";
    providerId: ProviderId;
    businessHours: WeeklySchedule;
};

const providerSetBusinessHoursCommandZodSchema: z.ZodSchema<ProviderSetBusinessHoursCommand> =
    z.object({
        _type: z.literal("PROVIDER_SET_BUSINESS_HOURS_COMMAND"),
        providerId: providerIdZodSchema,
        businessHours: weeklyScheduleZodSchema,
    });

export { providerSetBusinessHoursCommandZodSchema };
export type { ProviderSetBusinessHoursCommand };
